module.exports = __webpack_public_path__ + "img/callNumber.d6b218c6.png";